import { Component, OnInit, NgZone } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { SidebarService } from '../../services/sidebar.service';
import { GlobalService } from '../../services/global.service';

import { ModalService } from '../modal/modal.service';

import 'rxjs/add/operator/filter';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  public screenVisible: Boolean;
  public selectedClient: any;
  public error: string;

  public userType: number;
  public visible: boolean;
  public isTopGA: boolean;

  constructor(public sidebarService: SidebarService, private router: Router, private ngZone: NgZone, private globalService: GlobalService,private modalService: ModalService) {
    // This sidebar status should only occur when on a report page (viewing, editing, creating)
    //console.log(window.screen.height);
    this.router.events
    .filter(event => event instanceof NavigationEnd)
    .subscribe(event => this.handleSidebarStatus((event as NavigationEnd).url));

    // router.events.subscribe((evt) => {
    //   if (evt.constructor.name === 'NavigationEnd') {
      modalService.modal$.subscribe((modal) => {
        
      });
        
    //   }
    // });

    window.onresize = () => { // Detect screen size and resizing
      ngZone.run(() => {
        if (window.innerWidth < 900 && this.screenVisible) {
          this.screenVisible = false;
        } else if (window.innerWidth >= 900 && !this.screenVisible) {
          this.screenVisible = true;
        }
      })
    }
  }

  ngOnInit() {
    this.screenVisible = window.innerWidth < 900 ? false : true;
    this.userType = Number(localStorage.getItem('roleId')) || 3;

    this.visible = (Number(localStorage.getItem('orgID')) === 2 || Number(localStorage.getItem('parentID')) === 2) ? true : false;
    this.isTopGA = (Number(localStorage.getItem('roleId')) === 2 || Number(localStorage.getItem('roleId')) === 1) && Number(localStorage.getItem('parentID')) === 0 ? true : false;

    if(!this.globalService.hasSetFeatures){
      //this.getClientData();
      this.globalService.getOrganizationsFeatures();
    }
  }

  handleSidebarStatus(url) {
    if (url === '/reports/create/ss' || url === '/reports/create/mmt' || url === '/reports/create/ltc') {
      // this.sidebarService.openPartial();
      // this.getClientData();
    } else {
      this.sidebarService.open();
    }
  }

  getClientData() {
    this.globalService.getClientData(Number(localStorage.getItem("selectedClient")), 4)
    .subscribe(
        client => { this.selectedClient = client; },
        error => this.error = <any>error);
  }

  ngOnDestroy() {

  }

  handleContactUsModal(e) {
    this.modalService.add('contact-support', { ID: Number(localStorage.getItem("userId"))});
  }

  closeModal(){
    //console.log('on clcik');
    this.modalService.close();
  }
}
